var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_c('SeoHero',{attrs:{"scene":_vm.scene,"bike-type":"mountain"},on:{"cta":_vm.handleClick}},[_vm._v("\n      Mountain Bike Insurance "),_c('br'),_vm._v("You Can Trust\n    ")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Featured'),_vm._v(" "),_c('Thrillingly'),_vm._v(" "),_c('PeaceOfMind'),_vm._v(" "),_c('BlogWidget',{attrs:{"title":"Learn more about mountain biking","slugs":[
          'road-cycling-vs-mountain-biking-which-is-best-for-you',
          'how-to-get-started-in-mountain-biking',
          '10-best-gravel-roads-in-europe',
          '5-best-mountain-biking-destinations-in-the-uk',
        ]}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }